/**
 * Enum for temperature formats.
 * @readonly
 */
export const TemperatureUnit = Object.freeze({
  FAHRENHEIT: '°F',
  CELSIUS: '°C',
});

export default TemperatureUnit;
